import { isSamePublishClass } from '@/shared/utils/publish';
import { usePublishedBoxStore, publishQueries } from '@/entities/sets/publish';
import { usePersistStore } from '@/shared/lib/store';
import { NoDataNew } from '@/shared/ui/no-data';
import { ByPublishListFilter } from '@/widgets/filter';
import { ByPublishListTable } from '@/widgets/table-list';
import moment from 'moment';
import { useMemo, useEffect } from 'react';

export const ByPublishListTab = () => {
    const { sUserId } = usePersistStore();
    const {
        claIdList,
        filterClassList,
        searchKeyword,
        searchPage,
        selectClass,
        publishType,
        publishState,
        startDate,
        endDate,
        dateTab,
        setSelectClass,
        setSearchPage,
        setPublishType,
        setPublishState,
        setStartDate,
        setEndDate,
        setDateTab,
    } = usePublishedBoxStore();

    const startFrom = startDate ? moment(startDate).format('YYYY-MM-DD') : undefined;
    const endTo = endDate ? moment(endDate).format('YYYY-MM-DD') : undefined;

    const queryParams = useMemo(
        () => ({
            wrterId: sUserId,
            claIds: selectClass
                ? (claIdList
                      ?.filter((e) => isSamePublishClass(e.claId, selectClass.claId))
                      .map((e) => e.claId)
                      ?.join(',') ?? '')
                : '',
            keyword: searchKeyword,
            publishTypes: publishType?.join(','),
            sttsCds: publishState?.join(','),
            dateFrom: startFrom,
            dateTo: endTo,
            page: searchPage,
            size: 10,
        }),
        [
            sUserId,
            searchKeyword,
            publishType,
            publishState,
            endTo,
            startFrom,
            searchPage,
            selectClass,
            claIdList,
        ]
    );
    const { data, refetch, isFetched } = publishQueries.list.getPublishBoxList(
        queryParams,
        !!startFrom && !!endTo
    );

    useEffect(() => {
        const firstClassInfo = filterClassList[0]?.classInfo;
        const selectedClassSeq = selectClass?.claId.split('-')[4];
        const selectedClassExists = filterClassList.some(
            (classItem) => classItem.classInfo.classSeq.toString() === selectedClassSeq
        );

        if (selectedClassExists) return;

        if (!firstClassInfo) {
            if (selectClass) setSelectClass(undefined);
            return;
        }

        const { schName, classSeq, schCode, crtYear, schYear } = firstClassInfo;

        const processedSchName = schName?.replace('등학교', '');
        const claId = 'viva-' + schCode + '-' + crtYear + '-' + schYear + '-' + classSeq;
        setSearchPage(0);
        setSelectClass({ claId, name: processedSchName });
    }, [filterClassList, selectClass, setSearchPage, setSelectClass]);

    const onRefetch = () => refetch();

    return (
        <>
            <ByPublishListFilter
                selectClass={selectClass}
                setSelectClass={setSelectClass}
                filterClassList={filterClassList}
                startDate={startDate}
                endDate={endDate}
                dateTab={dateTab}
                publishType={publishType}
                publishState={publishState}
                setPublishType={setPublishType}
                setPublishState={setPublishState}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setDateTab={setDateTab}
            />
            {data && data?.publishList?.length > 0 ? (
                <ByPublishListTable data={data} refetch={onRefetch} />
            ) : (
                isFetched && (
                    <NoDataNew
                        titleBlue={searchKeyword}
                        titleBlack="검색 결과가 없습니다."
                        type={'keyword'}
                    />
                )
            )}
        </>
    );
};
